import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[noop]'
})
export class NoopDirective {
  @Input() set noop(value: any) { }
}
